import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import api, { formatApiError } from "../../lib/api";

export default function PdfDownload({ toolId, getPayload }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ email: "", name: "", organisation: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/public/tools/report", { tool_id: toolId, inputs: getPayload(), ...f }, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `VCAJ_${toolId}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Your PDF is downloading");
      setOpen(false);
    } catch (err) {
      let msg = formatApiError(err);
      if (err?.response?.status === 422) msg = "Please enter a valid email address";
      else if (err?.response?.data instanceof Blob) {
        try { msg = JSON.parse(await err.response.data.text()).detail || msg; } catch { /* keep default */ }
      }
      toast.error(typeof msg === "string" ? msg : "Could not generate the PDF");
    } finally { setBusy(false); }
  };

  const cls = "rounded-none h-11 border-slate-300 focus-visible:ring-[#C4A66A]";
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="h-12 px-6 text-sm font-semibold inline-flex items-center gap-2 border border-[#14263D] text-[#14263D] hover:bg-[#14263D] hover:text-white transition-colors" data-testid="tool-pdf-btn">
        <FileDown className="h-4 w-4" /> Download branded PDF
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="site max-w-md rounded-none border-t-4 border-t-[#C4A66A]" data-testid="tool-pdf-modal">
          <DialogHeader>
            <div className="site-eyebrow">Free report</div>
            <DialogTitle className="font-serif text-2xl text-[#14263D]">Get your result as a PDF</DialogTitle>
            <DialogDescription>Enter your email and the VCAJ-branded report downloads straight away.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-4" data-testid="tool-pdf-form">
            <Input required type="email" placeholder="Work email *" value={f.email} onChange={set("email")} className={cls} data-testid="tool-pdf-email" />
            <Input placeholder="Your name" value={f.name} onChange={set("name")} className={cls} data-testid="tool-pdf-name" />
            <Input placeholder="Organisation" value={f.organisation} onChange={set("organisation")} className={cls} data-testid="tool-pdf-org" />
            <button type="submit" disabled={busy} className="btn-site-navy w-full h-12 text-sm font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="tool-pdf-submit">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4" />} Download PDF
            </button>
            <p className="text-[11px] text-slate-500">We may contact you about this result. We never share your details.</p>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
